/**
 * Copyright 2025 Beijing Volcano Engine Technology Co., Ltd. All Rights Reserved.
 * SPDX-license-identifier: BSD-3-Clause
 */

import { Button, Divider, Popover } from '@arco-design/web-react';
import { IconMenu } from '@arco-design/web-react/icon';
import NetworkIndicator from '@/components/NetworkIndicator';
import { useIsMobile } from '@/utils/utils';
import Logo from '@/assets/img/Logo.svg';
import styles from './index.module.less';

const Disclaimer = 'https://ai.hubeixinli.com/';
const ReversoContext = 'https://ai.hubeixinli.com/';
const UserAgreement = 'https://ai.hubeixinli.com/';

interface HeaderProps {
  children?: React.ReactNode;
  hide?: boolean;
}

function Header(props: HeaderProps) {
  const { children, hide } = props;

  const MenuProps = [
    {
      name: '免责声明',
      url: Disclaimer,
    },
    {
      name: '隐私政策',
      url: ReversoContext,
    },
    {
      name: '用户协议',
      url: UserAgreement,
    },
  ];

  return (
    <div
      className={styles.header}
      style={{
        display: hide ? 'none' : 'flex',
      }}
    >
      <div className={styles['header-logo']}>
        {useIsMobile() ? null : (
          <Popover
            content={
              <div className={styles['menu-wrapper']}>
                {MenuProps.map((menuItem) => (
                  <Button
                    type="text"
                    key={menuItem.name}
                    onClick={() => {
                      window.open(menuItem.url, '_blank');
                    }}
                  >
                    {menuItem.name}
                  </Button>
                ))}
              </div>
            }
          >
            <IconMenu className={styles['header-setting-btn']} />
          </Popover>
        )}
        <img src={Logo} alt="Logo" />
        <Divider type="vertical" />
        <span className={styles['header-logo-text']}>心理测评实时对话式 AI </span>
        <NetworkIndicator />
      </div>
      {children}
      {useIsMobile() ? null : (
        <div className={styles['header-right']}>
          <div
            className={styles['header-right-text']}
            onClick={() =>
              window.open('https://ai.hubeixinli.com/', '_blank')
            }
          >
            官网链接
          </div>
          <div
            className={styles['header-right-text']}
            onClick={() =>
              window.open(
                'https://ai.hubeixinli.com/',
                '_blank'
              )
            }
          >
            联系我们
          </div>
        </div>
      )}
    </div>
  );
}

export default Header;
